import { StyledRadioWrapper, StyledRadioInput } from "../../../../../admin/searchPaymentPlan/PlanActions/PlanActionsRadioGroup/PlanActionsRadio/PlanActionsRadio.styled";

const CardChoiceRadio = ({ id, disabled, value, onChange, checked }) => {
    return (
        <StyledRadioWrapper>
            <StyledRadioInput
                className="form-check-input"
                type="radio"
                name="creditCardChoice"
                id={id}
                disabled={disabled}
                value={value}
                checked={checked}
                onChange={e => onChange(e.target.value)}
            />
        </StyledRadioWrapper>
    );
};

export default CardChoiceRadio;